<template>
  <div>
    <v-row dense class="mx-1">
      <v-btn depressed
             color="primary"
             class="rounded-tag-small normal-btn-text"
             link to="/cadastro-usuario"
             v-if="hasRoleAdmin">
        <v-icon>
          mdi-plus
        </v-icon>
        Usuário
      </v-btn>
      <v-spacer/>
      <v-btn icon @click="onClickRefresh">
        <v-icon left>mdi-refresh</v-icon>
      </v-btn>
      <px-search-text label="Busque por um usuário" v-model="searchText"
                      style="max-width: 400px"
                      class="rounded-card"
        :on-search="emitChange"/>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    onClickRefresh: {
      type: Function,
      required: true,
    },
  },
  methods: {
    emitChange() {
      this.$emit('change');
    },
  },
  computed: {
    ...mapGetters('user', ['hasRoleAdmin']),
    searchText: {
      get() {
        return this.$store.getters['listagemUsuario/searchText'];
      },
      set(searchText) {
        this.$store.dispatch('listagemUsuario/searchText', searchText);
      },
    },
  },
};
</script>
